{
  "actions": {
    "back": "Terug",
    "close": "Sluiten",
    "minimize": "Minimaliseren",
    "maximize": "Maximaliseren",
    "restore": "Herstellen",
    "open": "Openen",
    "save": "Opslaan",
    "cancel": "Annuleren"
  },
  "ui": {
    "loading": "Bezig met laden...",
    "ready": "Gereed",
    "error": "Er is iets misgegaan",
    "success": "Gelukt!",
    "clickForDetails": "Klik voor details"
  },
  "status": {
    "online": "Online",
    "offline": "Offline",
    "busy": "Bezig",
    "available": "Beschikbaar"
  },
  "navigation": {
    "home": "Home",
    "back": "Terug",
    "next": "Volgende",
    "previous": "Vorige"
  }
}